import React, { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth";

const topbarLinks = [
  { label: "ADMIN SUR4PLOTS", url: "https://admin.sur4plots.com" },
  { label: "ADMIN ZZIGS", url: "https://admin.zzigs.com" },
];

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const logOut = async (e) => {
    e.preventDefault();
    await signOut(auth);
    navigate("/");
  };

  // Obtenir le titre de la page actuelle
  const getPageTitle = () => {
    const path = location.pathname;
    const titles = {
      "/": "Accueil",
      "/users": "Utilisateurs",
      "/add": "Ajouter",
      "/searchs": "Recherches",
      "/matchs": "Matchs",
      "/finds": "Trouvailles",
      "/comments": "comments",
      "/categories": "Catégories",
      "/documents": "Documents",
      "/notifications": "Notifications",
    };
    return titles[path] || "Dashboard";
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
      {/* Topbar - Liens externes */}
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
        <div className="px-6 py-2 flex items-center justify-between">
          <div className="flex space-x-6 overflow-x-auto">
            {topbarLinks.map(({ label, url }, i) => (
              <a
                key={i}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-600 hover:text-[#ff9be4] transition-colors whitespace-nowrap flex items-center gap-1"
              >
                {label}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-3 h-3"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                  />
                </svg>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Navbar principale */}
      <div className="px-6 py-3 flex items-center justify-between">
        {/* Titre de la page */}
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0">
            <img
              src="/logo.png"
              alt="Logo"
              className="h-12 w-12 rounded-full object-cover border-2 border-[#ff9be4] shadow-md"
            />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-800">
              {getPageTitle()}
            </h1>
            <p className="text-sm text-gray-500">
              {new Date().toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
          </div>
        </div>

        {/* Actions à droite */}
        <div className="flex items-center gap-4">
          

          {/* Menu utilisateur */}
          <div className="relative">
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#ff9be4] to-[#ff6bd4] flex items-center justify-center text-white font-semibold shadow-md">
                A
              </div>
              <div className="hidden md:block text-left">
                <p className="text-sm font-medium text-gray-700">
                  Administrateur
                </p>
                <p className="text-xs text-gray-500">
                  {auth.currentUser?.email || "admin@sur4plots.com"}
                </p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className={`w-4 h-4 text-gray-600 transition-transform ${
                  showDropdown ? "rotate-180" : ""
                }`}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                />
              </svg>
            </button>

            {/* Dropdown menu */}
            {showDropdown && (
              <>
                <div
                  className="fixed inset-0 z-10"
                  onClick={() => setShowDropdown(false)}
                ></div>
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20">
                  <div className="px-4 py-2 border-gray-200">
                    <p className="text-sm font-medium text-gray-700">
                      Connecté en tant que
                    </p>
                    <p className="text-xs text-gray-500 truncate">
                      {auth.currentUser?.email || "admin@sur4plots.com"}
                    </p>
                  </div>
                  
                  
                  <hr className="my-2" />
                  <button
                    onClick={logOut}
                    className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
                      />
                    </svg>
                    Déconnexion
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}